import { useMutation } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const urlPrefix = "/system/indices/mappings";
const putFieldType = async ({ indexSetSelection, newFieldType, rotated, field }) => {
  const url = qualifyUrl(urlPrefix);
  const body = {
    index_sets: indexSetSelection,
    type: newFieldType,
    rotate: rotated,
    field
  };
  return fetch("PUT", url, body);
};
const usePutFieldTypeMutation = () => {
  const put = useMutation({
    mutationFn: putFieldType,
    onError: (errorThrown) => {
      UserNotification.error(
        `Changing the field type failed with status: ${errorThrown}`,
        "Could not change the field type"
      );
    },
    onSuccess: () => {
      UserNotification.success("The field type changed successfully", "Success!");
    }
  });
  return { putFieldTypeMutation: put.mutateAsync, isLoading: put.isPending };
};
export default usePutFieldTypeMutation;
